import Vue from 'vue';
import Component from 'vue-class-component';
/**
 * 开关
 */
@Component({
})
export default class OnOff extends Vue {
  // public get flage(): boolean {
  //   return this.$store.state.setPage.shortcutOpen;
  // }
  public flage: boolean = true;
  public type: string = '关闭';
  public handleonOff() {
    // this.$store.commit('setPage/shortcutOpen');
    this.flage = !this.flage;
    this.type =
      this.flage === true ? '开启' : '关闭';
    localStorage.flage = this.flage + '';
  }
  public mounted() {
    if (localStorage.flage !== undefined) {
      this.flage =
        localStorage.flage === 'true' ? true : false;
    } else {
      localStorage.flage = this.flage + '';
    }
    this.type =
      this.flage === true ? '开启' : '关闭';
  }
}



// WEBPACK FOOTER //
// ./src/views/Condition/components/OnOff/OnOff.ts